module.exports = __webpack_public_path__ + "7698e8a491fee90cfdb99ec9eab9bb38.png";